import type { DateRange } from "react-day-picker";
import { ReportScope } from "../services/model/ReportScope";
import { ReportType } from "../services/model/ReportType";

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function filenameFor(
  reportType: ReportType,
  scope: ReportScope,
  dateRange: DateRange | undefined,
  singleDate: Date | undefined,
  shiftName?: string | null
): string {
  const scopeSlug = slugify(scope.label);
  if (reportType === "posting-sheet") {
    const d = singleDate ?? new Date();
    const datePart = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
    const shiftSlug = shiftName ? slugify(shiftName) : "shift";
    return `posting-sheet_${scopeSlug}_${datePart}_${shiftSlug}.pdf`;
  }
  const from = dateRange?.from ?? new Date();
  const to = dateRange?.to ?? from;
  const rangePart = `${from.getFullYear()}${String(
    from.getMonth() + 1
  ).padStart(2, "0")}${String(from.getDate()).padStart(
    2,
    "0"
  )}-${to.getFullYear()}${String(to.getMonth() + 1).padStart(2, "0")}${String(
    to.getDate()
  ).padStart(2, "0")}`;
  const typeSlug =
    reportType === "timesheet" ? "timesheet" : "planned-vs-actuals";
  const shiftSuffix =
    shiftName && shiftName !== "all" ? `_${slugify(shiftName)}` : "";
  return `${typeSlug}_${scopeSlug}_${rangePart}${shiftSuffix}.xlsx`;
}
